import type { AppJournalEntry } from "@/vybe-trader-client/messaging/stores/useJournalStore";
import {
  getEntryDirection,
  getEntryType,
} from "./journalEntryUtils";

function csvEscapeCell(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function formatDatePart(value: number, length = 2): string {
  return value.toString().padStart(length, "0");
}

function formatCsvTimestamp(timestamp: number): string {
  const date = new Date(timestamp);
  return [
    date.getFullYear(),
    "-",
    formatDatePart(date.getMonth() + 1),
    "-",
    formatDatePart(date.getDate()),
    "T",
    formatDatePart(date.getHours()),
    ":",
    formatDatePart(date.getMinutes()),
    ":",
    formatDatePart(date.getSeconds()),
    ".",
    formatDatePart(date.getMilliseconds(), 3),
  ].join("");
}

export function buildJournalExportFilename(): string {
  const now = new Date();
  const stamp = [
    now.getFullYear(),
    formatDatePart(now.getMonth() + 1),
    formatDatePart(now.getDate()),
    formatDatePart(now.getHours()),
    formatDatePart(now.getMinutes()),
    formatDatePart(now.getSeconds()),
  ].join("-");
  return `vybe-journal-${stamp}.csv`;
}

export function downloadJournalCsv(
  filename: string,
  rows: AppJournalEntry[]
): void {
  const headers = ["timestamp", "messageType", "direction", "message", "payload"];
  const csvRows = rows.map((entry) => [
    formatCsvTimestamp(entry.timestamp),
    getEntryType(entry),
    getEntryDirection(entry),
    entry.message,
    entry.detail ?? "",
  ]);
  const csvBody = [
    headers.map(csvEscapeCell).join(","),
    ...csvRows.map((row) => row.map(csvEscapeCell).join(",")),
  ].join("\r\n");
  const blob = new Blob([`\uFEFF${csvBody}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
